import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useApp } from '@/context/AppContext';
import ProductCard from '@/components/products/ProductCard';

const FeaturedProducts = () => {
  const { products } = useApp();
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  // Get featured products (first 4)
  const featuredProducts = products.slice(0, 4);

  return (
    <section ref={sectionRef} className="py-16 md:py-24 bg-gradient-burgundy-soft">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-sm text-silver font-sans tracking-wider uppercase mb-2 block">
            Curated for You
          </span>
          <h2 className="font-display text-2xl md:text-3xl text-foreground mb-4">
            Featured Collections
          </h2>
          <p className="text-muted-foreground font-body max-w-xl mx-auto">
            Discover our most cherished pieces, crafted with love and blessed intentions
          </p>
        </motion.div>

        {/* Products Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {featuredProducts.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>

        {/* View All Button */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link to="/products">
            <Button variant="silver" size="lg" className="group">
              View All Products
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
